import { useMemo } from 'react';
import type { DmNotificationPatientRow } from '../../../services/dmNotifications';
import { useLeavingIds } from '../shared/useLeavingIds';

// Keyed by notification id, so a notification DM re-syncs later can show again.
export function useLeavingNotifications(rows: readonly DmNotificationPatientRow[]) {
    const presentIds = useMemo(
        () => rows.flatMap((row) => row.notifications.map((notification) => notification.id)),
        [rows]
    );
    return useLeavingIds(presentIds);
}
